import api from './api';

/**
 * Medicare-card OCR (Phase 6). Uploads a card image to the backend Tesseract endpoint and gets back
 * confirm-flow SUGGESTIONS: { fields: { mbi, firstName, lastName, dateOfBirth }, confidence,
 * needsManualEntry, message }. Never auto-submits - the caller pre-fills the form for the user to
 * verify and correct.
 */
const ocrService = {
  scanMedicareCard: (file, { sessionBinding } = {}) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/ocr/medicare-card', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      ...(sessionBinding ? { sessionBinding } : {}),
    });
  },
};

export default ocrService;
